import { useRef } from 'react';
import { Navigate, Routes as ReactRouterRoutes, Route, useLocation } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { AktionsaufgabeErstellen } from '../../pages/aktionsaufgabe-erstellen';
import { Aktionsaufgaben } from '../../pages/aktionsaufgaben';
import { IndividuelleAufgabeErstellen } from '../../pages/individuelle-aufgabe-erstellen';
import { Objekt } from '../../pages/objekt';
import { Objekte } from '../../pages/objekte';

export const Routes = () => {

  const location = useLocation();

  const nodeRef = useRef(null);

  return (
    <TransitionGroup component={null}>
      <CSSTransition
        key={location?.pathname}
        timeout={250}
        classNames="fade"
        nodeRef={nodeRef}
      >
        <div id="test" ref={nodeRef}>
          <ReactRouterRoutes location={location}>
            <Route path="objekte" element={<Objekte/>} />
            <Route path="objekte/:objektId" element={<Objekt/>} />
            <Route path="aktionsaufgabe" element={<Aktionsaufgaben/>} />
            <Route path="aktionsaufgabe-erstellen/:aufgabenId/:kampagnenName" element={<AktionsaufgabeErstellen/>} />
            <Route path="individuelle-aufgabe" element={<IndividuelleAufgabeErstellen/>} />
            <Route path="/" element={<Navigate replace to="/objekte" />} />
          </ReactRouterRoutes>
        </div>
      </CSSTransition>
    </TransitionGroup>
  );
};
